(() => {
  const main = document.querySelector("main[data-template='index']");
  const hero = main?.querySelector("[class^='spins-hero-premium-']");

  if (!main || !hero || hero.querySelector('.spins-home-doodles')) return;

  const shapes = [
    '<circle cx="24" cy="24" r="15"/><circle cx="24" cy="24" r="3"/>',
    '<rect x="9" y="9" width="30" height="30" rx="7"/><path d="M16 31l7-7 5 5 5-6 6 8"/>',
    '<path d="M24 8l17 31H7L24 8z"/><circle cx="24" cy="31" r="2"/>',
    '<path d="M24 9v30M9 24h30"/><circle cx="24" cy="24" r="4"/>',
    '<path d="M7 33C13 11 30 10 41 25"/><circle cx="7" cy="33" r="3"/><circle cx="41" cy="25" r="3"/><path d="M7 33l10-1M41 25l-9-5"/>',
    '<path d="M12 36l5-13L32 8l8 8-15 15-13 5zM17 23l8 8M32 8l8 8"/>',
    '<path d="M9 18V9h9M30 9h9v9M39 30v9h-9M18 39H9v-9"/><path d="M16 24h16M24 16v16"/>',
    '<rect x="7" y="14" width="34" height="20" rx="3"/><path d="M12 14v7M18 14v4M24 14v7M30 14v4M36 14v7"/>',
    '<path d="M24 8c-10 0-18 7-18 16s8 16 18 16h4a4 4 0 000-8h-2a3 3 0 010-6h7c6 0 9-4 9-8 0-6-8-10-18-10z"/><circle cx="15" cy="20" r="2"/><circle cx="21" cy="15" r="2"/><circle cx="29" cy="15" r="2"/>',
    '<rect x="7" y="10" width="34" height="28" rx="4"/><circle cx="17" cy="19" r="3"/><path d="M10 34l9-9 6 6 5-5 8 8"/>',
    '<path d="M10 7l27 18-13 3-6 13-8-34z"/><path d="M24 28l8 8"/>',
    '<path d="M35 17c-3-7-14-8-20-2-7 7-3 19 7 21 9 2 17-7 13-15-3-6-12-6-15 0-3 5 3 10 8 7"/>',
    '<path d="M8 12h32M8 24h32M8 36h32M12 8v32M24 8v32M36 8v32"/><circle cx="24" cy="24" r="4"/>',
    '<path d="M8 34c6-15 14-5 20-18 4-8 10-6 12-2"/><path d="M8 38c8-10 16 1 25-10"/><circle cx="40" cy="14" r="2"/>'
  ];

  const compact = window.matchMedia('(max-width: 749px)').matches;
  const doodleCount = compact ? 36 : 108;
  const random = (() => {
    let state = 0x5f3759df;
    return () => {
      state |= 0;
      state = (state + 0x6d2b79f5) | 0;
      let value = Math.imul(state ^ (state >>> 15), 1 | state);
      value = (value + Math.imul(value ^ (value >>> 7), 61 | value)) ^ value;
      return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
    };
  })();

  const placements = Array.from({ length: doodleCount }, () => ({
    x: 1.5 + random() * 97,
    y: 1.5 + random() * 95,
    size: (compact ? 18 : 20) + random() * (compact ? 16 : 24),
    opacity: 0.105 + random() * 0.085,
    rotation: -18 + random() * 36,
    duration: 12 + random() * 7,
    delay: random() * -18,
    shape: Math.floor(random() * shapes.length)
  }));

  const layer = document.createElement('div');
  layer.className = 'spins-home-doodles';
  layer.setAttribute('aria-hidden', 'true');

  placements.forEach((placement) => {
    const { x, y, size, opacity, rotation, duration, delay, shape } = placement;
    const item = document.createElement('span');
    item.className = 'spins-home-doodle';
    item.style.setProperty('--spins-doodle-x', `${x}%`);
    item.style.setProperty('--spins-doodle-y', `${y}%`);
    item.style.setProperty('--spins-doodle-size', `${size}px`);
    item.style.setProperty('--spins-doodle-opacity', opacity.toFixed(3));
    item.style.setProperty('--spins-doodle-rotation', `${rotation.toFixed(2)}deg`);
    item.style.setProperty('--spins-doodle-duration', `${duration.toFixed(2)}s`);
    item.style.setProperty('--spins-doodle-delay', `${delay.toFixed(2)}s`);
    item.innerHTML = `<svg viewBox="0 0 48 48" aria-hidden="true">${shapes[shape]}</svg>`;
    layer.appendChild(item);
  });

  hero.appendChild(layer);
})();
